import React from 'react';
import { ActivityIndicator, Platform } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import useResponsiveness from '@/hooks/useResponsiveness';
import { Image } from 'expo-image';
import DropdownIcon from '@/components/DropdownMenu/DropdownIcon';

function DropdownMenuItem({
  onSelect, 
  className,
  icon,
  iosIcon,
  imageUrl,
  title,
  subtitle,
  isDanger,
  isLoading,
  isActive,
  isSecondary,
  isTitleCentered = false,
  showInactiveIcon = false,
  isDisabled = false,
  inactiveIcon = undefined,
  ...props
}) {
  const { colors } = useTheme();    
  const { isXS } = useResponsiveness();
  const iconSize = isXS ? 16 : 14;

  const mainClasses = [
    "DropdownMenuItem",
    isDanger && "DropdownMenuItemDanger",
    isSecondary && "DropdownMenuItemSecondary",
    isActive && "DropdownMenuItemActive",
    isDisabled && "DropdownMenuItemDisabled",
    subtitle && "DropdownMenuItemWithSubtitle",
  ];

  return (
    <DropdownMenu.Item
      onSelect={isDisabled ? undefined : onSelect}
      className={mainClasses.join(' ')}
    >
      {
        (icon || imageUrl || iosIcon || isLoading) && (
          <DropdownMenu.ItemIcon
            className={`DropdownMenuItemIcon ${isActive ? "DropdownMenuItemIconAccent" : ""} ${isDanger ? "DropdownMenuItemIconDanger" : ""}`}
            ios={{
              name: iosIcon || icon,
              color: isDanger ? colors.color_destructive : isActive ? colors.accent_text_color : colors.text_color_primary
            }}
          >
            {isLoading && (
              <ActivityIndicator size="small" color={colors.text_color_primary} />
            )}
            {imageUrl ? (
              <Image
                accessibilityLabel=""
                source={{ uri: imageUrl }} 
                contentFit="cover"
                style={{ 
                  width: iconSize, 
                  height: iconSize, 
                  borderRadius: iconSize / 2 
                }} 
              />
            ) : (
              <Icon name={icon} size={iconSize} color={isDanger ? colors.color_destructive : colors.text_color_primary} />
            )}
          </DropdownMenu.ItemIcon>
        )
      }
      
      <DropdownMenu.ItemTitle className={`DropdownMenuItemTitle ${subtitle ? 'DropdownMenuItemTitleWithSubtitle' : ''}`}>
        <Text
          color={isDanger ? 'danger' : 'primary'}
          size={isXS ? 'm' : 'n'}
          style={{
            display:'flex',
            justifyContent: isTitleCentered ? 'center' : 'flex-start',
            alignItems: isTitleCentered ? 'center' : 'flex-start',
          }}
        >
          {title}
        </Text>
        {subtitle && (
          <Text
            color='tertiary'
            size='xs'
            numberOfLines={10}
            style={Platform.OS === 'web' ? {
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              overflowWrap: 'anywhere',
              maxWidth: '100%',
            } : undefined}
          >
            {subtitle}
          </Text>
        )}
      </DropdownMenu.ItemTitle>
      {
        (isActive || showInactiveIcon) && (
          <DropdownMenu.ItemIcon className="DropdownMenuItemIcon DropdownMenuItemIconActive">
            <DropdownIcon isActive={isActive} inactiveIcon={inactiveIcon} />
          </DropdownMenu.ItemIcon>
        )
      }
    </DropdownMenu.Item>
  );
}

export default DropdownMenuItem;